import { Button, Card } from 'flowbite-react';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useParams } from 'react-router';
import EditHooksModal from '../../../../components/Modals/EditHooks.modal';
import ExamService from '../../../../services/private/Exam/exam.service';

const Exmreg = () => {
    const { examId } = useParams();

    const [exmregData, setExmregData] = useState<any>({});
    const [showRegModal, setShowRegModal] = useState<boolean>(false);

    const getHooksData = async () => {
        await ExamService.getHooksData(examId).then((res: any) => {
            if (res.status === 200) {
                setExmregData({
                    EXMREG: res.data.EXMREG,
                    EXMREG_KEY: res.data.EXMREG_KEY
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const onUpdate = async () => {
        await ExamService.updateExamUrls(examId, { EXMREG: exmregData.EXMREG, EXMREG_KEY: exmregData.EXMREG_KEY }).then((res) => {
            if (res.status === 200) {
                toast.success("Succesfully Updated");
                setShowRegModal(false);
                getHooksData();
            }
        }).catch((err) => {
            toast.error("Failed to Update");
        });
    };

    useEffect(() => {
        getHooksData();
    }, []);

    return (
        <div className="ml-10 mt-10">
            <Card>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        EXMREG
                    </h5>
                    <Button onClick={() => setShowRegModal(true)}>
                        Edit
                    </Button>
                </div>
                <Card>
                    <div>
                        <p className="font-bold text-gray-700 dark:text-gray-400">
                            URL: {" "}{" "}{exmregData ? exmregData.EXMREG : "--"}
                        </p>
                        <p className="font-bold text-gray-700 dark:text-gray-400">
                            KEY: {" "}{" "}{exmregData ? exmregData.EXMREG_KEY : "--"}
                        </p>
                    </div>
                </Card>
            </Card>
            <EditHooksModal
                show={showRegModal}
                onClose={() => setShowRegModal(false)}
                stateData={exmregData}
                onChange={(new_state: any) => { setExmregData(new_state) }}
                onSubmission={onUpdate}
            />
        </div>
    )
}

export default Exmreg